import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import StickyButton from '@/components/atom/buttons/StickyButton';
import { StickyButtonWrapper } from '@/components/templates/communication/Magazine/MagazineDetailTemplate/index';
import { MagazineBottomButtonType, MagazineDetailVo } from '@/types/magazine';

interface Props {
  faq: MagazineDetailVo;
  bottomButtonText: string;
  shouldShowEventText: boolean;
  onClickButton: () => void;
}

const FaqStickeyButton: FunctionComponent<Props> = ({ faq, bottomButtonText, onClickButton, shouldShowEventText }) => {
  const EventContent = () => {
    switch (faq.bottomButtonType) {
      case MagazineBottomButtonType.DIAGNOSIS:
        return <></>;
      case MagazineBottomButtonType.QUESTION:
        return (
          <EventTextArea>
            <EventText>의료진 첫 답변</EventText>
            <HighlightedEventText>0원!</HighlightedEventText>
            <LineThroughEventText>1,900원</LineThroughEventText>
          </EventTextArea>
        );
    }
  };

  return (
    <StickyButtonWrapper>
      <StickyArea>
        <StickyButton.Button text={bottomButtonText} onClick={onClickButton} />
        {shouldShowEventText && <EventContent />}
      </StickyArea>
    </StickyButtonWrapper>
  );
};

export default FaqStickeyButton;

const StickyArea = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    div + div {
        margin: 0;
    }
`;

const EventTextArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
  gap: 4px;
`;

const EventText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI15M};
    color: ${theme.color.gray500};
  `};
`;

const HighlightedEventText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI15SB};
    color: ${theme.color.primary700};
  `};
`;

const _EventTextWrapper = styled.span``;

const LineThroughEventText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI12R};
    color: ${theme.color.gray300};
  `};
  text-decoration: line-through;
`;
